import { render } from "./PlatformAdmin.vue?vue&type=template&id=04fb2648&scoped=true"
import script from "./PlatformAdmin.vue?vue&type=script&lang=js"
export * from "./PlatformAdmin.vue?vue&type=script&lang=js"

import "./PlatformAdmin.vue?vue&type=style&index=0&id=04fb2648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fb2648"]])

export default __exports__